import setFullbanner from './home/1_fullbanner';
import setIconsVertical from './home/icons_vertical';
import setCarousel from '../components/carousel';
import setBannersLinha from './home/home_banner_linha';
//addImports

import setTopBar from '../components/topBar';
import handleConditionalLazy from '../components/conditionalLazy';

const Home = {
  init: function () {
    setTopBar();
    handleConditionalLazy();

    setFullbanner()
		setIconsVertical();
		setCarousel();
		setBannersLinha();
		//calls
  },
};

window.addEventListener('DOMContentLoaded', () => {
  Home.init();
});
